<template>
  <div id="left-level-navigation">
    <div class="left-list">
      <img src="@/assets/images/logo.jpg" class="logo" alt="" />
      <div
        class="left-list-item"
        v-for="item in nav"
        :key="item.id"
        @click="handleItem(item)"
      >
        <img :src="item.image" alt="" />
        <div class="left-list-item-title">{{ item.name }}</div>
      </div>
      <div class="posi">
        <div class="posi-re">
          <img
            class="posi-avatar"
            :src="
              dataVal.userinfo.headimage
                ? urls + dataVal.userinfo.headimage
                : avatar
            "
            alt=""
          />
          <div class="posi-pd">
            <div class="posi-nav">
              <div class="posi-nav-item" @click="handleNav(1)">
                <img
                  style="margin-right: 10px"
                  src="@/assets/images/home/z1.png"
                  alt=""
                />
                <div>账号设置</div>
              </div>
              <div class="posi-nav-item" @click="handleNav(2)">
                <img src="@/assets/images/home/z2.png" alt="" />
                <div>重置密码</div>
              </div>
              <div class="posi-nav-item" @click="handleNav(3)">
                <img src="@/assets/images/home/z3.png" alt="" />
                <div>系统刷新</div>
              </div>
              <div class="posi-nav-item" @click="handleNav(4)">
                <img src="@/assets/images/home/z4.png" alt="" />
                <div>退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AccountSettings
      :dataVal="dataVal"
      @accountSettingsCell="accountSettingsCell"
    ></AccountSettings>
    <Popup :dataVal="popupObj" @popupCell="popupCell"></Popup>
  </div>
</template>
<script>
//弹窗组件
import Popup from "@/components/header/Popup.vue";
//账号设置组件
import AccountSettings from "@/components/header/AccountSettings.vue";
export default {
  name: "LeftLevelNavigation",
  components: { AccountSettings, Popup },
  data() {
    return {
      dataVal: {
        flag: false,
        userinfo: "",
      },
      popupObj: {
        flag: false,
        title: "退出登录",
        content: "是否继续退出账号？",
        btn1: "退出",
        btn2: "取消",
        type: "",
      },
      nav: [
        {
          id: "1",
          name: "首页",
          url: "/workbench",
          image: require("@/assets/images/left/icon-l1.png"),
        },
        {
          id: "2",
          name: "基础业务",
          url: "/maternityMatron",
          image: require("@/assets/images/left/icon-l2.png"),
        },
        {
          id: "3",
          name: "云暖商城",
          url: "/productManagement",
          image: require("@/assets/images/left/icon-l3.png"),
        },
        {
          id: "4",
          name: "分销管理",
          url: "/distributor",
          image: require("@/assets/images/left/icon-l4.png"),
        },
        {
          id: "5",
          name: "系统设置",
          url: "/roleAuthorization",
          image: require("@/assets/images/left/icon-l5.png"),
        },
        {
          id: "64",
          name: "消息通知",
          url: "/unreadMessage",
          image: require("@/assets/images/left/icon-l6.png"),
        },
      ],
      id: "",
      urls: this.imgurl,
      avatar: require("@/assets/images/left/avatar.png"),
      fromData2: {
        page: 1,
        count: 10,
        status: 0,
      },
      total_count: 0,
    };
  },
  mounted() {
    this.indexGetinfo();
    if (this.dataVal.userinfo.menu_ids.split(",").indexOf("64") != -1) {
      this.messageLst();
    }
  },
  methods: {
    async messageLst() {
      let res = await this.$api.messageLst({
        ...this.fromData2,
      });
      if (res.code == 1) {
        this.total_count = res.data.total_count;
        this.nav.forEach((item, i) => {
          if (item.id == "64" && this.total_count == 0) {
            this.nav[i].image = require("@/assets/images/left/icon-l7.png");
          } else if (item.id == "64" && this.total_count > 0) {
            this.nav[i].image = require("@/assets/images/left/icon-l6.png");
          }
        });
      }
    },
    async indexGetinfo() {
      let res = await this.$api.indexGetinfo();
      if (res.code == 1) {
        this.dataVal.userinfo = res.data;
        localStorage.setItem("userinfo", JSON.stringify(res.data));
        if (this.dataVal.userinfo.role_id == 1) {
          return false;
        }

        if (this.dataVal.userinfo.menu_ids.split(",").indexOf("6") != -1) {
          this.nav[0].url = "/workbench";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("8") != -1
        ) {
          this.nav[0].url = "/loginLog";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("9") != -1
        ) {
          this.nav[0].url = "/reportCenter";
        }
        // 基础业务
        if (this.dataVal.userinfo.menu_ids.split(",").indexOf("10") != -1) {
          this.nav[1].url = "/maternityMatron";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("11") != -1
          ||this.dataVal.userinfo.menu_ids.split(",").indexOf("60") != -1
          ||this.dataVal.userinfo.menu_ids.split(",").indexOf("61") != -1
          ||this.dataVal.userinfo.menu_ids.split(",").indexOf("62") != -1
          ||this.dataVal.userinfo.menu_ids.split(",").indexOf("68") != -1
        ) {
          this.nav[1].url = "/customer";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("12") != -1
        ) {
          this.nav[1].url = "/taskCenter";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("13") != -1
        ) {
          this.nav[1].url = "/activity";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("14") != -1
        ) {
          this.nav[1].url = "/store";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("15") != -1
        ) {
          this.nav[1].url = "/learningGarden";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("16") != -1
        ) {
          this.nav[1].url = "/help";
        }
        //商城
        if (this.dataVal.userinfo.menu_ids.split(",").indexOf("17") != -1) {
          this.nav[2].url = "/productManagement";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("18") != -1
        ) {
          this.nav[2].url = "/productCategory";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("19") != -1
        ) {
          this.nav[2].url = "/orderManagement";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("20") != -1
        ) {
          this.nav[2].url = "/afterSalesOrder";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("21") != -1
        ) {
          this.nav[2].url = "/welfareVerification";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("22") != -1
        ) {
          this.nav[2].url = "/timeLimitedFlashSale";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("23") != -1
        ) {
          this.nav[2].url = "/exclusiveForNewcomers";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("24") != -1
        ) {
          this.nav[2].url = "/freeShipping";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("27") != -1
        ) {
          this.nav[2].url = "/coupon";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("28") != -1
        ) {
          this.nav[2].url = "/notice";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("25") != -1
        ) {
          this.nav[2].url = "/carousel";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("26") != -1
        ) {
          this.nav[2].url = "/member";
        }
        //分销
        if (this.dataVal.userinfo.menu_ids.split(",").indexOf("63") != -1) {
          this.nav[3].url = "/distributor";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("32") != -1
        ) {
          this.nav[3].url = "/commissionWithdrawal";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("31") != -1
        ) {
          this.nav[3].url = "/distributionOrder";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("30") != -1
        ) {
          this.nav[3].url = "/customCommission";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("29") != -1
        ) {
          this.nav[3].url = "/distributionSettings";
        }
        //系统设置
        if (this.dataVal.userinfo.menu_ids.split(",").indexOf("33") != -1) {
          this.nav[4].url = "/roleAuthorization";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("34") != -1
        ) {
          this.nav[4].url = "/employeeAccount";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("35") != -1
        ) {
          this.nav[4].url = "/pointsManagement";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("36") != -1
        ) {
          this.nav[4].url = "/dataDictionary";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("37") != -1
        ) {
          this.nav[4].url = "/activitySetting";
        } else if (
          this.dataVal.userinfo.menu_ids.split(",").indexOf("38") != -1
        ) {
          this.nav[4].url = "/eventDisclaimer";
        }
        let arr = [];
        this.nav.forEach((item, i) => {
          if (
            this.dataVal.userinfo.menu_ids.split(",").indexOf(item.id) != -1
          ) {
            arr.push(item);
          }
        });
        this.nav = arr;
      }
    },
    handleItem(item) {
      if (this.$route.path == item.url) {
        return false;
      }
      if (item.id == this.id) {
        return false;
      }
      this.id = item.id;
      this.$router.push(item.url);
    },
    handleNav(type) {
      this.popupObj.type = type;
      if (type == 1) {
        this.dataVal.flag = true;
      } else if (type == 2) {
        this.popupObj.title = "重置密码";
        this.popupObj.content = "是否继续重置密码？";
        this.popupObj.btn1 = "重置";
        this.popupObj.flag = true;
      } else if (type == 3) {
        this.popupObj.title = "系统刷新";
        this.popupObj.content = "是否继续刷新系统？";
        this.popupObj.btn1 = "刷新";
        this.popupObj.flag = true;
      } else if (type == 4) {
        this.popupObj.title = "退出登录";
        this.popupObj.content = "是否继续退出账号？";
        this.popupObj.btn1 = "退出";
        this.popupObj.flag = true;
      }
    },
    accountSettingsCell(val) {
      if (val.submitFlag) {
        this.indexGetinfo();
      }
      this.dataVal.flag = val.flag;
    },
    popupCell(val) {
      if (val.submitFlag) {
        if (this.popupObj.type == 2) {
          // window.localStorage.clear();
          window.location.href =
            "#/forgotPassword?type=" + localStorage.getItem("type");
        }
        if (this.popupObj.type == 3) {
          location.reload();
        }
        if (this.popupObj.type == 4) {
          window.localStorage.removeItem("type");
          window.localStorage.removeItem("userinfo");
          window.localStorage.removeItem("token");
          window.location.href = "#/login";
          // this.$router.push("/login");
        }
      }
      this.popupObj.flag = val.flag;
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.id = val.matched[1].meta.id;
        // this.messageLst();
        if (this.dataVal.userinfo.menu_ids.split(",").indexOf("64") != -1) {
          this.messageLst();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
#left-level-navigation {
  width: 115px;
  height: 100vh;
  background-color: $y-color;
  position: relative;
  .left-list {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .logo {
      margin: 44px 0 40px;
      width: 53px;
      height: 53px;
      border-radius: 11px;
    }
    .left-list-item {
      margin-bottom: 47px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
      img {
        display: block;
        width: 25px;
        height: 25px;
        height: auto;
      }
      .left-list-item-title {
        font-size: 13px;
        color: #fff;
        margin-top: 5px;
      }
    }
  }
  .posi {
    position: absolute;
    bottom: 35px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 9;
    .posi-avatar {
      width: 55px;
      height: 55px;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
    }
    .posi-pd {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(100%, -67%);
      z-index: 10;
      padding-left: 9px;
      display: none;
      .posi-nav {
        background-color: #fff;
        width: 205px;
        border-radius: 14px;
      }
      .posi-nav-item {
        display: flex;
        align-items: center;
        height: 42px;
        color: #404040;
        font-size: 14px;
        font-weight: 600;
        width: 100%;
        padding-left: 10px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.2556);
        cursor: pointer;
        img {
          margin-right: 14px;
        }
      }
      .posi-nav-item:last-child {
        border-bottom: none;
      }
      .posi-nav-item:hover {
        color: $y-color;
      }
    }
    .posi-re {
      position: relative;
    }
    .posi-re:hover .posi-pd {
      display: block;
    }
  }
}
</style>